import { Component, OnInit } from '@angular/core';
import { NgForm } from "@angular/forms";

import { LoanService } from "../shared/loan.service";
import { LoantransactionService } from "../shared/loantransaction.service";
import { Loan } from '../shared/loan';

@Component({
  selector: 'app-loaninstallments',
  templateUrl: './loaninstallments.component.html',
  styleUrls: ['./loaninstallments.component.css']
})
export class LoaninstallmentsComponent implements OnInit {

  InstallmentsList: any[] = [];

  constructor(public loanService: LoanService, private loantransactionService: LoantransactionService) { }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.loanService.selectedInstallments = {
      Id: 0,
      LoanId: null,
      WeekOfYear :  null,
      DayOfWeek : null,
      Date :  null,
      InstallmentAmount : null,
      EmployeeId  : null,
      EmployeeBranchId  : null,
      CompanyId  : null,
      SaasId  : null,
      IsActive : null,
      Flag: 0
    }
  }

  getInstallmentsList(loanId:any){
    this.loanService.FetchInstallmentsList(loanId)
    .toPromise()
    .then(data =>{
      this.InstallmentsList =data;
      console.log(data);
    })
    .catch(err => { console.log(err) });
  }

  public ClickSearch(event :any){

    this.getInstallmentsList(this.loanService.selectedInstallments.LoanId);

    // this.loanService.selectedLoan.Id = this.loanService.selectedInstallments.LoanId;
    // this.loanService.LoanApprovalByLoanNo(this.loanService.selectedLoan.Id).subscribe(data => {
    //         //  console.log(this.loanService.selectedLoanreceipt);
    //   console.log(data);

    // })

    // this.loanService.FetchLoanByLoanNo(this.loanService.selectedLoan).subscribe(loandata => {
    //   this.loanService.selectedLoan = loandata;
    //   this.loanService.selectedLoan.CustomerId =loandata.CustomerId;
    //   // console.log(this.loanService.selectedLoan);
    // })

    event.preventDefault();
  }

}
